// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3OvXA","label":"Completed_label__2r6ss"};